import { jsx as r, jsxs as x } from "react/jsx-runtime";
import { useState as y } from "react";
import S from "@mui/icons-material/ExpandMore";
import h from "@mui/material/Accordion";
import A from "@mui/material/AccordionDetails";
import g from "@mui/material/AccordionSummary";
import u from "@mui/material/Box";
import I from "@mui/material/List";
import N from "@mui/material/ListItem";
import b from "@mui/material/ListItemText";
import { makeStyles as j } from "tss-react/mui";
import C from "./AccordionV2.style.js";
const D = j()(C), E = ({ language: n, dataList: s }) => {
  const [d, l] = y(!1), { classes: t } = D(), p = (a) => (o, e) => {
    l(e ? a : !1);
  };
  return /* @__PURE__ */ r(u, { className: t.accordian, children: s && s.map((a) => {
    const { id: o, label: e, desc: f } = a, c = e[n], i = f[n];
    return /* @__PURE__ */ x(
      h,
      {
        expanded: d === String(o),
        onChange: p(String(o)),
        className: t.accordianItem,
        children: [
          /* @__PURE__ */ r(
            g,
            {
              expandIcon: /* @__PURE__ */ r(S, { fontSize: "large" }),
              "aria-controls": c,
              id: String(o),
              className: t.accordianSummary,
              children: c
            }
          ),
          /* @__PURE__ */ r(A, { className: t.accordianDetail, children: Array.isArray(i) ? /* @__PURE__ */ r(
            I,
            {
              sx: { listStyle: "initial", margin: "0", padding: "0" },
              children: i == null ? void 0 : i.map((m) => /* @__PURE__ */ r(N, { sx: { display: "list-item" }, children: /* @__PURE__ */ r(b, { primary: m }) }, m))
            }
          ) : i })
        ]
      },
      o
    );
  }) });
}, F = E;
export {
  F as default
};
